module.exports = __webpack_public_path__ + "img/border.f9e02690.gif";